import { isValid } from "date-fns"
import { Observer } from "mobx-react-lite"
import { rem, size } from "polished"
import { lazy } from "react"
import styled, { css } from "styled-components"

const EmbedTimestamp = lazy(() => import("./EmbedTimestamp"))

const Container = styled.div.attrs((props) => ({
  $hasthumbnail: props.$hasthumbnail,
}))`
  min-width: 0;

  margin: 8px 0 0;

  display: flex;
  align-items: center;

  grid-row: auto / auto;
  grid-column: 1 / 2;

  ${({ $hasthumbnail }) =>
    $hasthumbnail === "true" &&
    css`
      grid-column: 1 / 3;
    `};
`

const FooterImage = styled.img`
  ${size(20)};

  margin: 0 8px 0 0;

  object-fit: contain;
  border-radius: 50%;
`

const FooterText = styled.span`
  font-size: ${rem(12)};
  font-weight: 500;
  color: ${({ theme }) => theme.text.normal};
  line-height: ${rem(16)};

  white-space: pre-wrap;
  white-space: break-spaces;

  ${({ theme }) =>
    theme.appearance.color === "light" &&
    css`
      @media (max-resolution: 1dppx) {
        font-weight: 500;
      }
    `};
`

const FooterSeparator = styled.span`
  display: inline-block;
  margin: 0 4px;
`

export function EmbedFooter(props) {
  const { embed } = props

  return (<Observer>{() => (
    <Container $hasthumbnail={`${Boolean(embed.thumbnail)}`}>
      {embed.footer.icon_url && (
        <FooterImage src={embed.footer.icon_url} alt="Footer image" />
      )}
      <FooterText>
        {embed.footer.text}
        {embed.footer.text && isValid(embed.timestamp) && (
          <FooterSeparator>•</FooterSeparator>
        )}
        {isValid(embed.timestamp) && (
          <EmbedTimestamp timestamp={embed.timestamp} />
        )}
      </FooterText>
    </Container>
  )}</Observer>)
}
